import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './lang' // 国际化
import 'element-ui/lib/theme-chalk/index.css'
import './css/common/index.less'
import 'babel-polyfill'
Vue.use(ElementUI, { size: 'small' })
Vue.prototype.$axios = axios
// import 'lib-flexible/flexible.js'

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)

})



// WEBPACK FOOTER //
// ./src/main.js